import { dataProps, 
        measurementProfileListProps,
        photoListProps,
        addressProps,
        discussionProps } from './properties'

export const setCustomerMasterList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setCustomerMasterOrderList = (state, payload) => {
    state.order_list = payload
}

export const setCustomerMasterAutocompleteList = (state, payload) => {
    state.autocomplete_list = payload
}


export const setCustomerMasterData = (state, payload) => {
    state.props = payload.response
    state.statement.list = []
    if(state.props.photo_list.length === 0) {
        state.props.photo_list = [JSON.parse(JSON.stringify(photoListProps))]
    } else {
        state.props.photo_list.push(JSON.parse(JSON.stringify(photoListProps)))
    }
    if(state.props.address_list.length === 0) {
        state.props.address_list = [JSON.parse(JSON.stringify(addressProps))]
    }

    if(state.props.discussion_list === null) {
        state.props.discussion_list = []    
    }
    state.props.discussion_list.push(JSON.parse(JSON.stringify(discussionProps)))
} 

export const setCustomerMasterMeasurementData = (state, payload) => {
    state.props.loading_measurements = false

    const responsePayload = JSON.parse(JSON.stringify(payload))

    const distinctTailoringCategoryId = responsePayload.filter((thing, index, self) =>
        index === self.findIndex((t) => (
            t.tailoring_category_id === thing.tailoring_category_id
        ))
    )

    const distinctRegistrationDate = responsePayload.filter((thing, index, self) =>
        index === self.findIndex((t) => (
            t.registration_date === thing.registration_date
        ))
    )

    let measurement_profile_list = []

    distinctTailoringCategoryId.forEach(tailoringCategory => {

        let profile_list = []
        let key = 0

        distinctRegistrationDate.forEach(date => {

            const msmtFilterList = responsePayload.filter((thing, index, self) =>
                index === self.findIndex((t) => (
                    t.registration_date === date.registration_date 
                        && tailoringCategory.measurement_profile_id === thing.measurement_profile_id 
                            && t.tailoring_category_id === tailoringCategory.tailoring_category_id
                ))
            )

            msmtFilterList.forEach(profile => {

                const msmtFields = responsePayload
                    .filter(t => t.measurement_profile_id === profile.measurement_profile_id 
                            && t.tailoring_category_id === tailoringCategory.tailoring_category_id)
                
                let measurement_field_list = []
                msmtFields.forEach(msmt => {
                    measurement_field_list.push(msmt)
                })

                profile_list.push({
                    key: key,
                    id: profile.measurement_profile_id,
                    tailoring_category_id: profile.tailoring_category_id,
                    size_id: profile.size_id,
                    measurement_type: profile.measurement_type,
                    registration_date: profile.registration_date,
                    registration_date_formatted: profile.registration_date_formatted,
                    notes: profile.notes,
                    measured_by_staff_id: profile.measured_by_staff_id,
                    measurement_field_list
                })

                key ++

            })
            
        })

        measurement_profile_list.push({
            tailoring_category_id: tailoringCategory.tailoring_category_id,
            profile_list
        })

    })
    
    state.props.measurement_profile_list = measurement_profile_list
    state.props.temp_measurement_profile_list = []

    /*state.props.measurement_profile_list = payload.measurement_profile_list
    state.props.temp_measurement_profile_list = payload.temp_measurement_profile_list*/
}

export const resetCustomerMasterMeasurementData = state => {
    state.props.loading_measurements = false
    state.props.measurement_profile_list = []
    state.props.temp_measurement_profile_list = []
}

export const setLoadingMeasurements = state => {
    state.props.loading_measurements = true
}

export const unSetLoadingMeasurements = state => {
    state.props.loading_measurements = false
}

export const addNewCustomerMasterMeasurementProfileListRow = (state, tailoring_category_id) => {

    let listIndex = state.props.temp_measurement_profile_list.findIndex((t) => t.tailoring_category_id === tailoring_category_id)
    let key = 0
    
    if(listIndex>=0) {
        state.props.temp_measurement_profile_list[listIndex].profile_list.push(JSON.parse(JSON.stringify(measurementProfileListProps)))

        state.props.temp_measurement_profile_list[listIndex].profile_list.forEach(element => {
            element.key = key

            key ++
        })
    }

}

export const removeCustomerMasterMeasurementProfileListRow = (state, payload) => {

    let listIndex = state.props.temp_measurement_profile_list.findIndex((t) => t.tailoring_category_id === payload.tailoring_category_id)

    let key = 0

    state.props.temp_measurement_profile_list[listIndex].profile_list.splice(payload.key, 1)

    state.props.temp_measurement_profile_list[listIndex].profile_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const addNewCustomerMasterPhotoListRow = state => {

    let key = 0
    state.props.photo_list.push(JSON.parse(JSON.stringify(photoListProps)))

    state.props.photo_list.forEach(element => {
        element.key = key
        key ++
    })
    
}

export const removeCustomerMasterPhotoListRow = (state, payload) => {

    let key = 0

    state.props.photo_list.splice(payload, 1)

    if(state.props.photo_list.length === 0) {
        state.props.photo_list = [JSON.parse(JSON.stringify(photoListProps))]
    }

    state.props.photo_list.forEach(element => {
        element.key = key
        if(payload === key) {
            element.photo = ""
        }
        key ++
    })

}

export const addNewAddressListItemRow = state => {

    let sl_no = 0
    state.props.address_list.push(JSON.parse(JSON.stringify(addressProps)))

    state.props.address_list.forEach(element => {
        element.key = sl_no
        element.edit_mode = false
        sl_no ++
    })

    state.props.address_list[state.props.address_list.length-1].edit_mode = true

    setTimeout(() => {
        document.getElementById('contact_name_'+(sl_no-1)).focus()
    }, 300);

}

export const removeAddressListItemRow = (state, payload) => {

    let sl_no = 0

    state.props.delete_address_list.push(state.props.address_list[payload])

    state.props.address_list.splice(payload, 1)

    if(state.props.address_list.length === 0) {
        state.props.address_list = [JSON.parse(JSON.stringify(addressProps))]
    }

    state.props.address_list.forEach(element => {
        element.key = sl_no
        element.edit_mode = false
        sl_no ++
    })

    state.props.address_list[state.props.address_list.length-1].edit_mode = true

    setTimeout(() => {
        document.getElementById('contact_name_'+(sl_no-1)).focus()
    }, 300);
    
}

export const setCustomerMasterStatementList = (state, payload) => {
    state.statement.list = payload
}

export const setCustomerDD = (state, payload) => {
    state.customer_dd = payload.response
}

export const resetCustomerMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const setCustomerMasterImportListRow = (state, payload) => {
    state.import_customer_list = payload
}

export const resetCustomerMasterImportList = state => {
    state.import_customer_list = []
}


// WEBPACK FOOTER //
// ./src/store/modules/customerMaster/mutations.js